import GreyScoop from "../Assets/GreyScoop.png"
import RedScoop from "../Assets/RedScoop.png"
import PrintedBandeau from "../Assets/PrintedBandeau.png"
import TexturedBlue from "../Assets/TexturedBlue.png"
import PurpleGlitter from "../Assets/PurpleGlitter.png"
import PurpleBandeau from "../Assets/PurpleBandeau.png"
import Printed from "../Assets/Printed.png"
import OrangeCrochet from "../Assets/OrangeCrochet.png"

let new_collection = [
    {
        id:25,
        name: "Grey Scoop Kini",
        image: GreyScoop,
        price: 80.00,
    }, 

    {
        id:26,
        name: "Red Scoop Kini",
        image: RedScoop,
        price: 80.00,
    },

    {
        id:27,
        name: "Printed Bandeau Kini",
        image: PrintedBandeau,
        price: 80.00,
    },

    {
        id:28,
        name: "Textured Blue Kini",
        image: TexturedBlue,
        price: 80.00,
    },

    {
        id:29,
        name: "Purple Glitter Kini",
        image: PurpleGlitter,
        price: 80.00,
    },

    {
        id:30,
        name: "Purple Bandeau Kini",
        image: PurpleBandeau,
        price: 80.00,
    },

    {
        id:31,
        name: "Printed Kini",
        image: Printed,
        price: 80.00,
    },

    {
        id:32,
        name: "Orange Crochet Kini",
        image: OrangeCrochet,
        price: 80.00,
    },
];

export default new_collection;